module.exports = __webpack_public_path__ + "static/media/260.0955e089.wav";